import { render, staticRenderFns } from "./TeamTimeOffBalances.vue?vue&type=template&id=a28a1ff6&scoped=true"
import script from "./TeamTimeOffBalances.vue?vue&type=script&lang=js"
export * from "./TeamTimeOffBalances.vue?vue&type=script&lang=js"
import style0 from "./TeamTimeOffBalances.vue?vue&type=style&index=0&id=a28a1ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a1ff6",
  null
  
)

export default component.exports